export function setYear(params) {
    return {
        type: 'SET_YEAR',
        payload: params
    }
}

export function setMonth(params) {
    return {
        type: 'SET_MONTH',
        payload: params
    }
}

export function setDay(params) {
    return {
        type: 'SET_DAY',
        payload: params
    }
}

export function setDate(params) {
    return {
        type: 'SET_DATE',
        payload: params
    }
}
